import { render, staticRenderFns } from "./quizzDashLocal.vue?vue&type=template&id=8565b6f0&"
import script from "./quizzDashLocal.vue?vue&type=script&lang=js&"
export * from "./quizzDashLocal.vue?vue&type=script&lang=js&"
import style0 from "./quizzDashLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports